import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useState } from 'react';

import SvgColorImg from '../SvgColorImg';

const CaseButton = function CaseButton(props) {
  const {
    className,
    onClick,
    // description,
    imgSrc,
    Image,
    label,
    disabled,
    id,
    name,
    secondaryColor,
    imgColor = '#FFFFFF',
    imgClassname,
    absolute,
    noFrame,
    disabledColor = '#A6A6A6',
    small,
    xsmall,
    border,
    white,
    onMouseDown,
    onMouseUp,
  } = props;
  const [animate, setAnimate] = useState(false);

  const buttonClassname = classNames(
    'shrink-0',
    {
      'opacity-60': disabled,
      absolute,
      'relative': (!absolute) && (!className),
      'flex flex-col items-center justify-center gap-1 text-sm font-semibold': label,
    },
    className,
  );

  const roundDivClassName = classNames(
    'rounded-full flex items-center justify-center overflow-hidden shrink-0',
    {
      'bg-pxPrimary': (!noFrame) && (!secondaryColor) && (!white),
      'bg-pxSecondary': (!noFrame) && secondaryColor && (!white),
      'bg-white/80': white,
      'h-12 w-12': (!small) && (!xsmall),
      'h-8 w-8 p-2': small,
      'h-6 w-6 p-1': xsmall,
      border,
      'border-pxPrimary': (!disabled),
    },

  );

  const roundButtonDiv = (
    <div className={roundDivClassName}>
      {(imgSrc)
        ? (
            <SvgColorImg
              src={imgSrc}
              description="."
              className={classNames(
                'h-7 w-7',
                imgClassname,
              )}
              imgColor={(disabled && disabledColor) ? disabledColor : imgColor}
            />
          )
        : null}

      {(Image)
        ? (
            <Image
              src={imgSrc}
              description="."
              className={classNames(
                'h-7 w-7',
                imgClassname,
              )}
              style={{ fill: ((disabled && disabledColor) ? disabledColor : imgColor) }}
            />
          )
        : null}

      <div
        className={classNames(
          'absolute top-0 left-0 w-full h-full scale-0 opacity-0 bg-white rounded-full border-0',
          {
            'animate-ripple': animate,
          },
        )}
        onAnimationEnd={() => { setAnimate(false); }}
      />
    </div>
  );

  if (!label) {
    return (
      <button
        type="button"
        disabled={disabled}
        className={buttonClassname}
        id={id}
        name={name}
        onClick={(event) => {
          setAnimate(true);
          onClick(event);
        }}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
      >
        {roundButtonDiv}
      </button>
    );
  }

  return (
    <button
      type="button"
      disabled={disabled}
      className={buttonClassname}
      id={id}
      name={name}
      onClick={(event) => {
        setAnimate(true);
        onClick(event);
      }}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
    >
      {roundButtonDiv}
      {label}
    </button>
  );
};

CaseButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  imgSrc: PropTypes.string,
  Image: PropTypes.elementType,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  secondaryColor: PropTypes.bool,
  imgColor: PropTypes.string,
  imgClassname: PropTypes.string,
  absolute: PropTypes.bool,
  noFrame: PropTypes.bool,
  disabledColor: PropTypes.string,
  small: PropTypes.bool,
  xsmall: PropTypes.bool,
  border: PropTypes.bool,
  white: PropTypes.bool,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
};

export default CaseButton;
